<template>
  <m-dialog
    ref="dlg"
    @save="save"
    :title="device && device.perangkat_id ? 'Ubah Data Perangkat Instansi' : 'Tambah Data Perangkat Instansi'"
  >
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="7" lg="7" xl="7" class="py-0">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <label class="caption mb-2">Letak Perangkat Instansi</label>
            <v-text-field
              autofocus
              dense
              single-line
              outlined
              label="Letak Perangkat Instansi*"
              hint="Sebagai Data informasi Trend Perangkat Instansi, Contoh: Perangkat Instansi Lobby"
              persistent-hint
              v-model="device.nama"
              data-vv-name="nama"
              data-vv-as="Lokasi Perangkat Instansi"
              :error-messages="errors.collect('form.nama')"
            ></v-text-field>
            <v-layout wrap>
              <v-flex md6 class="py-0">
                <label class="caption mb-2">Latitude</label>
                <v-text-field
                  dense
                  single-line
                  outlined
                  label="Latitude*"
                  v-model="device.latitude"
                  hint="Masukkan garis lintang untuk menentukan lokasi"
                  type="number"
                  data-vv-name="latitude"
                  data-vv-as="Latitude"
                  :error-messages="errors.collect('form.latitude')"
                ></v-text-field>
              </v-flex>
              <v-flex md6 class="py-0">
                <label class="caption mb-2">Longitude</label>
                <v-text-field
                  dense
                  single-line
                  outlined
                  label="Longitude*"
                  v-model="device.longitude"
                  hint="Masukkan garis bujur untuk menentukan lokasi"
                  type="number"
                  data-vv-name="longitude"
                  data-vv-as="Longitude"
                  :error-messages="errors.collect('form.longitude')"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-col>
        <v-col v-if="isValidateLokasi" cols="12" sm="10" md="7" lg="7" xl="7">
          <div class="title primary--text mb-3"> Lokasi Presensi Perangkat </div>
          <v-text-field label="Cari Lokasi" append-icon="mdi-magnify" outlined dense v-model="textSearch" />

          <div class="d-flex justify-space-between my-3 mx-3">
            <div>
              <span class="primary--text">{{ selected.length }}</span> Lokasi Terpilih
            </div>
            <div class="primary--text" style="cursor: pointer" @click="showLokasi"> Lihat Lokasi Terpilih </div>
          </div>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="lokasiPresensi"
            :items-per-page="10"
            :page.sync="page"
            :checkboxColor="'primary'"
            light
            item-key="lokasi_presensi_id"
            show-select
            hide-default-footer
            @page-count="pageCount = $event"
          />
          <div class="text-center pt-2">
            <v-pagination v-model="page" :length="pageCount" />
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog" max-width="600px" color="primary text-white">
      <v-card>
        <v-card-title class="headline primary--text">Lokasi Terpilih</v-card-title>
        <v-card-text>
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-left">Nama</th>
                <th class="text-left">Lokasi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in selected" :key="item.lokasi_presensi_id">
                <td>{{ item.nama }}</td>
                <td>{{ item.alamat }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Tutup</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </m-dialog>
</template>

<script>
export default {
  name: 'PopupPerangkat',

  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      roles: [],
      device: {},
      defDevice: {
        tanggal: null,
        keterangan: null,
      },
      headers: [
        { text: 'Nama', align: 'left', value: 'nama' },
        { text: 'Lokasi', align: 'left', value: 'alamat' },
      ],
      selected: [],
      textSearch: null,
      page: 1,
      dialog: false,
      pageCount: 0,
      itemsPerPage: 10,
    }
  },
  mounted() {},
  computed: {
    lokasiPresensi() {
      const itemsLokasi = (this.current_organisasi && this.current_organisasi.lokasi_presensis) || []
      return itemsLokasi.filter((item) =>
        item.nama.toLowerCase().includes(this.textSearch ? this.textSearch.toLowerCase() : '')
      )
    },
    isValidateLokasi() {
      return (this.current_konfigurasi && this.current_konfigurasi.is_validate_lokasi_perangkat) || false
    },
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.$validator.reset()
      this.selected = []

      this.$store.dispatch('device/detail', {
        organisasi_id: this.organisasi_id,
        id_device: obj.perangkat_id,
      }).then(({ data }) => {
        this.device = data ? { ...data, ...{ kode_organisasi: this.organisasi_id } } : { ...this.defDevice }
        this.setMapLokasi()
        return this.$refs.dlg.open()
      })
    },
    save() {
      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          const lokasi_ids = this.selected.map((item) => item.lokasi_presensi_id) || []
          return this.$store.dispatch('device/form', Object.assign({}, this.device, { lokasi_ids }))
        })
        .then((res) => {
          this.$refs.dlg.resolve()
          this.$router.push({ name: 'device' })
          this.$emit('reload')
          this.$success('Perubahan berhasil disimpan')
          return res
        })
        .catch((e) => e)
    },
    setMapLokasi() {
      const itemsLokasi = (this.current_organisasi && this.current_organisasi.lokasi_presensis) || []
      const lokasis = (this.device.lokasi_presensis || []).map((item) => item.lokasi_presensi_id) || []
      lokasis.forEach((key) => {
        let find = itemsLokasi.find((item) => item.lokasi_presensi_id === +key) || {}
        if (Object.keys(find).length > 0) {
          this.selected.push(find)
        }
      })
    },
    showLokasi() {
      if (this.selected.length > 0) {
        this.dialog = true
      } else {
        this.$error('Pilih Lokasi Presensi terlebih dahulu')
      }
    },
  },
}
</script>
